import React from 'react';
import styled from '@emotion/styled';

import { DocumentPath } from '../../../types';
import { Link, LinkProps } from '../../Link/Link';
import { ImageMapLinkEditor } from './ImageMapLinkEditor';

export interface ImageMapLinkProps extends LinkProps {
  path: DocumentPath;
}

export function ImageMapLink({
  children,
  path,
  ...linkProps
}: React.PropsWithChildren<ImageMapLinkProps>) {
  return (
    <ImageMapLinkEditor path={path}>
      <StyledLink {...linkProps}>{ children || ' ' }</StyledLink>
    </ImageMapLinkEditor>
  );
}

const StyledLink = styled(Link)`
  position: absolute;
`;
